import { RowMenu } from '@components/RowMenu';
import { RowMenuItem } from '@components/RowMenuItem';
import { IMenu } from '@hooks/useMenu';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import { IVendedorMovimentacao } from '@model/VendedorMovimentacao';
import React from 'react';

export type VendedorMovimentacaoMenuProps = {
    menu: IMenu
    vendedorMovimentacao: IVendedorMovimentacao
}

export function VendedorMovimentacaoMenu ({ vendedorMovimentacao, menu }: VendedorMovimentacaoMenuProps) {
    const handleBaixarRecibo = React.useCallback(() => {
        window.open(`/ProtocoloMovimentacao/${vendedorMovimentacao.vendedorMovimentacaoId}`);
    }, [vendedorMovimentacao.vendedorMovimentacaoId]);

    return (
        <RowMenu menu={menu}>
            <RowMenuItem 
                key={0} 
                onClick={menu.handleItemClick(handleBaixarRecibo)}
                text="Baixar Recibo"
                icon={<CloudDownloadIcon />}
            />
        </RowMenu>
    )
}